<div id="prospectus">
    <div class="container-fluid ">
        <div class="row">
            <div class="col-md-3">
                <nav id="secondary-navigation">
                    <!-- Header -->
                    <header class="header">
                        <h5>Prospectus</h5>
                    </header>
                    <!-- /Header -->
                    <ul>
                        <li class="first">
                            <a  (click)="changeRoute('2024')">2023-24</a>
                        </li>
                        <li class="second">
                            <a  (click)="changeRoute('2023')">2022-23</a>
                        </li>
                        <li class="third">
                            <a  (click)="changeRoute('2022')">2021-22</a>
                        </li>
                        <li class="fourth">
                            <a  (click)="changeRoute('2021')">2020-21</a>
                        </li>
                        <li class="fifth">
                            <a  (click)="changeRoute('2020')">2019-20</a>
                        </li>
                        <li class="sixth">
                            <a  (click)="changeRoute('2019')">2018-19</a>
                        </li>
                        <li class="seven">
                            <a  (click)="changeRoute('2018')">2017-18</a>
                        </li>
                        
                    </ul>
                </nav>
            </div>
            <div class="col-md-9">
                <div id="sports">
                    <div class="container-fluid pdf">
                        <div class="row">
                            <div class="col-12">
                                <div class="card shadow-lg">
                                    
                                    <h5 class="card-title text-center">Prospectus</h5>
    
                                    <div class="container-fluid d-flex justify-content-center align-items-center h-100" id="loader" *ngIf="isLoading">
                                        <app-loader></app-loader>
                                    </div>
                                    <div id="detail" class="text-center">
                                        <pdf-viewer [src]="src" 
                                        [render-text]="true"
                                        style="display: block;"
                                        id="list-view"
                                        
                                        (on-progress)="hideLoader()" (error)="hideLoader()"></pdf-viewer>
    
                                </div>
                
                            </div>
                        </div>
                
                       
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



<!-- <div id="prospectus">
    <div class="row">
        <div class="col-12">
            <h4 class="card-title text-center ">Prospectus</h4>
            <div class="container-fluid d-flex justify-content-center align-items-center h-100" id="loader" *ngIf="isLoading">
                <app-loader></app-loader>
            </div>
            <div id="detail" class="text-center">
                <pdf-viewer [src]="pdfSrc" 
                [render-text]="true"
                style="display: block;"
                id="list-view"
                
                (on-progress)="hideLoader()" (error)="hideLoader()"></pdf-viewer>
            </div>
        </div>
    </div>
</div> -->